import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Comment out or remove lines that reference reportWebVitals
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// reportWebVitals(console.log);
